import * as React from "react"

export type Props = {
	label?:string|JSX.Element|(boolean|string|JSX.Element)[]
	name?:string
	value?:string
	checked?:boolean
	disabled?:boolean
	onChange?:(newChecked:boolean) => void
}

export const Checkbox = (props:Props) => {
	const box = unlabelledBox({
		name: props.name,
		value: props.value,
		checked: props.checked,
		disabled: props.disabled,
		onChange: props.onChange,
	})

	return props.label == undefined
		? box
		: <label className="sbCheckboxLabel">{box}{props.label}</label>
}

type UnlabelledProps = {
	name?:string
	value?:string
	checked?:boolean
	disabled?:boolean
	onChange?:(newChecked:boolean) => void
}

const unlabelledBox = (props:UnlabelledProps) => <input
	type="checkbox"
	name={props.name}
	value={props.value}
	checked={props.checked}
	disabled={props.disabled}
	onChange={(event:React.FormEvent<HTMLInputElement>) => {
		event.stopPropagation()
		if (props.onChange) {
			props.onChange(event.currentTarget.checked)
		}
	}}
	className="sbRadioButton"
/>



// WEBPACK FOOTER //
// ./src/lib/sbhtml/checkbox.tsx